import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 2px;
  margin: 20px 0;
`;
export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 10px;
  font-size: 13px;
  display: grid;
  grid-template-columns: 90% 10%;
  align-items: center;
  background-color: ${({ theme }) => theme.neutral.white};
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  &:hover {
    background-color: #f7eaf7;
  }
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 0;
    visibility: hidden;
  }
  :hover .icon-container {
    visibility: visible;
  }
`;
